<template>
  <div
    class="dashboard-grid"
    :style="{ gridTemplateColumns: `repeat(${columns}, 1fr)` }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DashboardGrid',
  props: {
    columns: {
      type: Number,
      required: false,
      default: 3,
      validator: (value) => Number.isInteger(value) && value > 0
    }
  }
}
</script>

<style lang="scss">
.dashboard-grid {
  display: grid;
  gap: 14px;
}
</style>
